module.exports = __webpack_public_path__ + "static/media/loader-white.6606bbed.svg";